// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isOfferfitAppGroupIdUseCasesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      offerfit_client: string,
      offerfit_pipeline: string,
      offerfit_usecase: string,
      usecase_display_name: string,
      status: enumOf("live", "draft"),
      // Second arg allows explicit JSON null, so a conman contract drift (present
      // pipeline with null product_type) degrades gracefully instead of failing
      // response validation.
      pipeline_type: maybe(string, true),
    })
  ),
});
